module.exports = __webpack_public_path__ + "static/media/romantic-vacation.0939bcb5.png";